/* eslint-disable import/no-duplicates -- типы для этих модулей находятся в одном файле, но объявлены как разные модули, eslint не понимает этого */
import ru from "date-fns/locale/ru"
import { format as dateFnsFormat, isToday, isYesterday } from "date-fns"

import { SentryWrapper } from "./ThirdParty/Sentry/SentryWrapper"

export const DEFAULT_LOCALE = ru

export function format(date: Date, format: string): string {
    try {
        return dateFnsFormat(date, format, { locale: DEFAULT_LOCALE, weekStartsOn: 1 })
    } catch (e: unknown) {
        if (e instanceof RangeError) {
            SentryWrapper.getInstance().captureException(e, { extra: { argument: date } })
        }
    }
    return date.toString()
}

export function formatToLong(datetime: string) {
    return format(new Date(datetime), "d\u00A0MMMM, iiii в\u00A0HH:mm")?.replace(".,", ",")
}

export function formatDateToLong(date: Date) {
    return format(date, "PPP")
}

export function formatToShort(datetime: string) {
    return format(new Date(datetime), "d\u00A0MMMM в\u00A0HH:mm")
}

export function formatTodMHm(datetime: string) {
    return format(new Date(datetime), "d\u00A0MMMM\u00A0HH:mm")
}

export function formatToWeekDays(datetime: string) {
    return format(new Date(datetime), "iiii, HH:mm")
}

export function formatToDayAndMonth(datetime: Date) {
    return format(new Date(datetime), "d MMMM")
}

export function formatToFull(datetime: Date) {
    return format(new Date(datetime), "dd.MM.yyyy HH:mm:ss")
}

export function formatToDate(datetime: string) {
    return format(new Date(datetime), "dd.MM.yyyy")
}

export function formatToTotal(datetime: Date) {
    return format(new Date(datetime), "d MMMM, EEEE, HH:mm")
}

export function formatTodME(datetime: Date) {
    return format(new Date(datetime), "d MMMM, EEEE")
}

export function formatToHoursAndMinutes(datetime: Date) {
    return format(new Date(datetime), "HH:mm")
}

export function formatToyMd(datetime: Date) {
    return format(new Date(datetime), "yyyy-MM-dd")
}

export function formatTodMy(datetime: Date) {
    return format(new Date(datetime), "dd.MM.yy")
}

export function formatToyLd(datetime: Date) {
    return format(new Date(datetime), "yyyy-LL-dd")
}

export function formatToWeekday(datetime: Date) {
    return format(new Date(datetime), "EEEE")
}

export function formatToDayMonthTime(datetime: Date) {
    return format(new Date(datetime), "d MMMM HH:mm")
}

export function formatToRelativeDateTime(datetime: Date): string {
    const time = format(datetime, "HH:mm")
    if (isToday(datetime)) return `Сегодня в ${time}`
    if (isYesterday(datetime)) return `Вчера в ${time}`
    return `${format(datetime, "d MMMM")} в ${time}`
}

export function formatCountdown(ms: number) {
    return format(new Date(ms), "mm:ss")
}
